/**
 * 漫画书架：auto-fill 栅格 + 固定列宽上限。
 * 单册时不拉伸为整行海报；多册时从左到右折行，列宽稳定在约 168–204px。
 */
export const comicBookshelfGridClass = [
  'grid w-full min-w-0 content-start items-start',
  'grid-cols-[repeat(auto-fill,minmax(min(100%,10.5rem),12.75rem))]',
  'gap-2.5 sm:gap-3 lg:gap-3.5',
  'sm:grid-cols-[repeat(auto-fill,minmax(min(100%,11rem),13rem))]',
  'lg:grid-cols-[repeat(auto-fill,minmax(min(100%,11.5rem),13.25rem))]',
  'xl:grid-cols-[repeat(auto-fill,minmax(min(100%,12rem),14rem))]',
].join(' ')

/** 栅格单元：占满列轨，不额外撑宽 */
export const comicBookshelfItemClass = 'min-w-0 w-full max-w-full'
